import { render, staticRenderFns } from "./Carousal.vue?vue&type=template&id=b7be607c&scoped=true"
import script from "./Carousal.vue?vue&type=script&lang=js"
export * from "./Carousal.vue?vue&type=script&lang=js"
import style0 from "./Carousal.vue?vue&type=style&index=0&id=b7be607c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7be607c",
  null
  
)

export default component.exports